export function buildAccumulatedTranscript(
  lastFinal: string,
  turn: string,
  isFinal: boolean
): string {
  if (!lastFinal) {
    return turn;
  }
  const separator = isFinal ? '. ' : ' ';
  return lastFinal + separator + turn;
}
